var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#1F1F1F",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4801 35.7301C27.283 35.7304 27.0933 35.6553 26.9501 35.5201L19.9501 28.5201C19.6576 28.2272 19.6576 27.7529 19.9501 27.4601L26.9501 20.4601C27.2429 20.1676 27.7172 20.1676 28.0101 20.4601C28.153 20.5994 28.2336 20.7905 28.2336 20.9901C28.2336 21.1897 28.153 21.3808 28.0101 21.5201L21.5501 28.0001L28.0001 34.4501C28.143 34.5894 28.2236 34.7805 28.2236 34.9801C28.2236 35.1797 28.143 35.3708 28.0001 35.5101C27.8646 35.6521 27.6763 35.7318 27.4801 35.7301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.52 28.75H20.52C20.1058 28.75 19.77 28.4142 19.77 28C19.77 27.5858 20.1058 27.25 20.52 27.25H35.52C35.9342 27.25 36.27 27.5858 36.27 28C36.27 28.4142 35.9342 28.75 35.52 28.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4801 35.7301C27.283 35.7304 27.0933 35.6553 26.9501 35.5201L19.9501 28.5201C19.6576 28.2272 19.6576 27.7529 19.9501 27.4601L26.9501 20.4601C27.2429 20.1676 27.7172 20.1676 28.0101 20.4601C28.153 20.5994 28.2336 20.7905 28.2336 20.9901C28.2336 21.1897 28.153 21.3808 28.0101 21.5201L21.5501 28.0001L28.0001 34.4501C28.143 34.5894 28.2236 34.7805 28.2236 34.9801C28.2236 35.1797 28.143 35.3708 28.0001 35.5101C27.8646 35.6521 27.6763 35.7318 27.4801 35.7301Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.52 28.75H20.52C20.1058 28.75 19.77 28.4142 19.77 28C19.77 27.5858 20.1058 27.25 20.52 27.25H35.52C35.9342 27.25 36.27 27.5858 36.27 28C36.27 28.4142 35.9342 28.75 35.52 28.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLeft);
export default __webpack_public_path__ + "static/media/Round-Left.6319a7b9.svg";
export { ForwardRef as ReactComponent };